import React, { useEffect, useState } from 'react'
import { Button, Dropdown, Form, Modal } from 'react-bootstrap'
import * as Api from "../../../../Config/Apis"
import endPoints from "../../../../Config/endPoints";
import * as Icon from 'react-bootstrap-icons';
import _ from "underscore"
import MiniEditor from './MiniEditor';
import htmlToDraft from "html-to-draftjs";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import DatePicker from "react-datepicker";
import moment from 'moment';
import { formatDate } from '../../../../Config/formatDate';
import ResponsivePagination from 'react-responsive-pagination';
import { useLocation, useNavigate } from 'react-router-dom';
import CurrencyFormat from 'react-currency-format';


const ChargerType = ["ALL", "AC", "DC"]
const init = {
    "title": "",
    "sub_title": "",
    "description": "",
    "show_banner": true,
    "discountType": "FIXED",
    "discountPercentage": "",
    "chargerType": "ALL",
    "min_value": "",
    "max_value": "",
    "isActive": true,
    "applicableOnPartners": false,
    "includedChargers": [],
    "excludedChargers": [],
    "usageLimitPerUser": 1,
    "globalUsageLimit": 1000,
    "fixedStartDate": new Date(),
    "fixedEndDate": "",
    "usageLimit": false
}
export default function SessionDiscount() {
    const searchParams = new URLSearchParams(window.location.search)
    let navigate = useNavigate()
    const location = useLocation()
    const [loading, setloading] = useState(true)
    const [list, setlist] = useState([])
    const [chargerlist, setChargerlist] = useState([])
    const [itemData, setItemData] = useState({})
    const [logs, setLogs] = useState([])
    const [modal, setModal] = useState({
        data: {},
        show: false,
        type: "",
        title: ""
    })
    const [value, setValue] = useState(init)
    const [editorState, setEditorState] = useState(() =>
        EditorState.createEmpty()
    );
    const [contentState, setcontentState] = useState()
    const [data, setData] = useState("");

    let limit = 20
    const [count, setCount] = useState(1)
    const [params, setParams] = useState({
        discountType: searchParams.get("discountType") || "",
        page: searchParams.get("page") || 1,
    })
    const [logpage, setLogpage] = useState(1)
    const [logsCount, setLogsCount] = useState(1)
    const [file, setFile] = useState(null)
    const [file2, setFile2] = useState(null)
    const [preview, setpreview] = useState(null)
    const [preview2, setpreview2] = useState(null)
    const handleFileChange = (event) => {
        let reader = new FileReader();
        let profile = event.target.files[0];
        if (profile.type.startsWith("image/")) {

            reader.onloadend = () => {
                if (profile.size <= 10000000) {
                    if (event.target.name === "banner_image") {
                        setpreview(reader.result)
                        setFile(profile)
                    } else {
                        setpreview2(reader.result)
                        setFile2(profile)
                    }
                } else {
                    Api.Alert("Max file size 10MB", "error")
                }

            };

        } else {
            Api.Alert("Uploaded file is not a valid image. Only JPG, PNG and GIF files are allowed. ", "error")
        }

        if (!_.isUndefined(profile)) {
            reader.readAsDataURL(profile);
        }
    }
    console.log(value)

    //Set/Delete param
    const setparam = (key, val) => {
        searchParams.set(key, val)
        const to = { pathname: location.pathname, search: searchParams.toString() };
        navigate(to, { replace: true });
    }
    const deleteparam = (key) => {
        searchParams.delete(key)
        const to = { pathname: location.pathname, search: searchParams.toString() };
        navigate(to, { replace: true });
    }

    const getList = (param) => {
        Api.GetApi(`${endPoints.SESSIONDISCOUNT}${param}`).then(res => {
            setloading(false)
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
            } else {
                if (res.data.data) {
                    setlist(res.data.data.data || [])
                    handleClose()

                    let newCount = Math.ceil(parseInt(res.data.data.pagination?.total) / limit)
                    if (newCount !== 0) {
                        let items = [];
                        for (let number = 1; number <= newCount; number++) {
                            items.push(number);
                        }
                        setCount(items)
                    } else {
                        setCount(1)
                    }
                } else {
                    setCount(1)
                }
            }
        })
    }

    const setCurrentPage = (number) => {
        if (number !== parseInt(params.page)) {
            setParams({ ...params, page: number })
            setparam("page", number)
            setloading(true)
        } else {
            setparam("page", number)
            setParams({ ...params, page: number })
        }
    }
    const setCurrentLogPage = (number) => {
        setLogpage(number)
        if (modal.data && modal.data._id) {
            Api.GetApi(`${endPoints.SESSIONDISCOUNTLOGS}?discountId=${modal.data._id}&page=${number}`).then(res => {
                if (res.error === true) {
                    Api.Alert(res.response.data.error, "error")
                } else {
                    setLogs(res.data.data)
                }
            })
        }
    }
    const getChargersList = () => {
        Api.GetApi(endPoints.CHARGERSONLY).then(res => {
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
            } else {
                if (res.data.data) {
                    setChargerlist(res.data.data)
                }
            }
        })
    }

    const handleClose = () => {
        setModal({
            ...modal,
            data: {},
            show: false,
            type: "",
            title: ""
        })
        setLogpage(1)
        setLogsCount(1)
        setpreview(null)
        setpreview2(null)
        setFile(null)
        setFile2(null)
        setValue(init)
        setEditorState(EditorState.createEmpty())
    }

    const createEditorStateFromHTML = (html) => {
        if (!html) {
            return EditorState.createEmpty();
        }

        const blocksFromHTML = htmlToDraft(html);

        const contentState = ContentState.createFromBlockArray(
            blocksFromHTML.contentBlocks,
            blocksFromHTML.entityMap
        );

        return EditorState.createWithContent(contentState);
    };

    const addNew = () => {
        setModal({
            ...modal,
            show: true,
            type: "add",
            title: "Add new discount"
        })
    }
    const handleChange = (e) => {
        if (e.target.name === "max_value") {
            setValue({ ...value, [e.target.name]: e.target.value })
        } else {
            setValue({ ...value, [e.target.name]: e.target.value })
        }
    }
    const toggleActiveState = (e) => {
        setValue({ ...value, [e.target.name]: e.target.checked })
    }
    const toggleStats = (data) => {
        setModal({
            ...modal,
            data: data,
            show: true,
            type: "status",
        })
    }
    const handleSubmit = () => {
        let data = new FormData();
        if (value.max_value < value.min_value) {
            return Api.Alert('Max amount should be more than min amount', "error")
        }
        if (!value.fixedStartDate) {
            return Api.Alert('Please select start date', "error")
        }
        if (!value.fixedEndDate) {
            return Api.Alert('Please select end date', "error")
        }
        if (modal.type === "add") {
            if (!file || !file2) {
                return Api.Alert('Please select image', "error")
            }
            if (value.usageLimit) {
                data.append("usageLimitPerUser", value.usageLimitPerUser || 0)
                data.append("globalUsageLimit", value.globalUsageLimit || 0)
            } else {
                data.append("usageLimitPerUser", 0)
                data.append("globalUsageLimit", 0)
            }
            data.append("banner_image", file)
            data.append("header_image", file2)
            data.append("title", value.title || "")
            data.append("sub_title", value.sub_title || "")
            data.append("description", value.description)
            data.append("show_banner", value.show_banner || true)
            data.append("discountType", value.discountType || "FIXED")
            data.append("discountPercentage", value.discountPercentage || 0)
            data.append("chargerType", value.chargerType || "")
            data.append("min_value", value.min_value || 0)
            data.append("max_value", value.max_value || 0)
            data.append("applicableOnPartners", value.applicableOnPartners || false)
            // data.append("fixedStartDate", moment(value.fixedStartDate).format('YYYY-MM-DD, h:mm:ss a') || "")
            // data.append("fixedEndDate", moment(value.fixedEndDate).format('YYYY-MM-DD, h:mm:ss a') || "")
            data.append("fixedStartDate", new Date(value.fixedStartDate).toISOString())
            data.append("fixedEndDate", new Date(value.fixedEndDate).toISOString())
            if (value.includedChargers.length > 0) {
                for (let i = 0; i < value.includedChargers.length; i++) {
                    data.append("includedChargers", value.includedChargers[i])
                }
            }
            if (value.excludedChargers.length > 0) {
                for (let i = 0; i < value.excludedChargers.length; i++) {
                    data.append("excludedChargers", value.excludedChargers[i])
                }
            }

            Api.PostApi(endPoints.SESSIONDISCOUNT, data).then(res => {
                if (res.error === true) {
                    Api.Alert(res.response.data.error, "error")
                } else {
                    if (res.data.data) {
                        Api.Alert("Added successfully!", "success")
                        getList(location.search)
                    }
                }
            })
        } else {
            if (file) {
                data.append("banner_image", file)
            } else {
                if (modal.data.banner_image) {
                    data.append("banner_image", modal.data.banner_image)
                }
            }
            if (file2) {
                data.append("header_image", file2)
            } else {
                if (modal.data.header_image) {
                    data.append("header_image", modal.data.header_image)
                }
            }
            data.append("isActive", value.isActive)

            if (value.usageLimit) {
                data.append("usageLimitPerUser", value.usageLimitPerUser || 0)
                data.append("globalUsageLimit", value.globalUsageLimit || 0)
            } else {
                data.append("usageLimitPerUser", 0)
                data.append("globalUsageLimit", 0)
            }
            data.append("title", value.title || "")
            data.append("sub_title", value.sub_title || "")
            data.append("description", value.description)
            data.append("show_banner", value.show_banner)
            data.append("discountType", value.discountType || "FIXED")
            data.append("discountPercentage", value.discountPercentage || 0)
            data.append("chargerType", value.chargerType || "")
            data.append("min_value", value.min_value || 0)
            data.append("max_value", value.max_value || 0)
            data.append("applicableOnPartners", value.applicableOnPartners || false)
            data.append("fixedStartDate", new Date(value.fixedStartDate).toISOString())
            data.append("fixedEndDate", new Date(value.fixedEndDate).toISOString())
            if (value.includedChargers.length > 0) {
                for (let i = 0; i < value.includedChargers.length; i++) {
                    data.append("includedChargers", value.includedChargers[i])
                }
            }
            if (value.excludedChargers.length > 0) {
                for (let i = 0; i < value.excludedChargers.length; i++) {
                    data.append("excludedChargers", value.excludedChargers[i])
                }
            }

            Api.PutApi(`${endPoints.SESSIONDISCOUNT}/${modal.data._id}`, data).then(res => {
                if (res.error === true) {
                    Api.Alert(res.response.data.error, "error")
                } else {
                    if (res.data.data) {
                        Api.Alert("Updated successfully!", "success")
                        getList(location.search)
                    }
                }
            })
        }
    }
    const handleConfirm = () => {
        if (modal.data && modal.data._id) {
            if (modal.type === "delete") {
                Api.DeleteApi(`${endPoints.SESSIONDISCOUNT}/delete/${modal.data._id}`).then(res => {
                    if (res.error === true) {
                        Api.Alert(res.response.data.error, "error")
                    } else {
                        Api.Alert(res.data.data, "success")
                        getList(location.search)
                    }
                })
            }
            else {
                Api.GetApi(`${endPoints.SESSIONDISCOUNT}/${modal.data._id}/toggle-status`).then(res => {
                    if (res.error === true) {
                        Api.Alert(res.response.data.error, "error")
                    } else {
                        Api.Alert(res.data.data, "success")
                        getList(location.search)
                    }
                })
            }
        }
    }
    const showModal = (data, type) => {
        if (type === "logs") {
            Api.GetApi(`${endPoints.SESSIONDISCOUNTLOGS}?discountId=${data._id}&page=1`).then(res => {
                if (res.error === true) {
                    Api.Alert(res.response.data.error, "error")
                } else {
                    setLogs(res.data.data)

                    let newCount = Math.ceil(parseInt(res.data.data.pagination?.total) / limit)
                    if (newCount !== 0) {
                        let items = [];
                        for (let number = 1; number <= newCount; number++) {
                            items.push(number);
                        }
                        setLogsCount(items)
                    } else {
                        setLogsCount(1)
                    }

                    setModal({
                        ...modal,
                        data: data,
                        show: true,
                        type: type,
                        title: `${type} (${data?.title})`
                    })
                }
            })
        } else {
            if (type === "view") {
                setItemData(data)
            }
            if (type === "edit") {
                setValue({ ...value, "url": data.url || "", isActive: data.isActive, usageLimit: data.usageLimitPerUser || data.globalUsageLimit })
                setEditorState(createEditorStateFromHTML(data.description));
                if (data.banner_image) {
                    setpreview(data.banner_image)
                }
                if (data.header_image) {
                    setpreview2(data.header_image)
                }
            }
            let x = {
                ...data,
                "fixedStartDate": new Date(data.fixedStartDate),
                "fixedEndDate": new Date(data.fixedEndDate),
            }
            setValue(x)
            setModal({
                ...modal,
                data: data,
                show: true,
                type: type,
                title: `${type} discount`
            })
        }
    }


    const updateTextDescription = async (state) => {
        await setEditorState(state);
    };
    const onContentStateChange = (contentState) => {
        setValue((prev) => ({
            ...prev,
            description: draftToHtml(contentState),
        }));
    }
    const [editorInitialized, setEditorInitialized] = useState(false);

    useEffect(() => {
        if (editorInitialized || !value?.description) return;

        const blocksFromHTML = htmlToDraft(value.description);

        const contentState = ContentState.createFromBlockArray(
            blocksFromHTML.contentBlocks,
            blocksFromHTML.entityMap
        );

        setEditorState(
            EditorState.createWithContent(contentState)
        );

        setEditorInitialized(true);
    }, [value?.description, editorInitialized]);

    const getDropdownLabel = (selectedItems) => {
        const activeKeys = Object.keys(selectedItems).filter((key) => key);
        if (activeKeys.length === 0) return 'Select Options';
        return `Selected (${activeKeys.length})`;
    };
    const handleCheckboxChange = (type, id) => {
        setValue((prev) => {
            const currentIds = prev[type] || [];

            const updatedIds = currentIds.includes(id)
                ? currentIds.filter((item) => item !== id)
                : [...currentIds, id];

            return {
                ...prev,
                [type]: updatedIds,
            };
        });
    };

    const onDateChange = (date, name) => {
        if (name === "fixedStartDate") {
            setValue({ ...value, [name]: date, "fixedEndDate": "" })
        } else {
            setValue({ ...value, [name]: date })
        }
    }

    useEffect(() => {
        getChargersList()
    }, [])

    useEffect(() => {
        const to = { pathname: location.pathname, search: searchParams.toString() };
        navigate(to, { replace: true });
        getList(location.search)
    }, [params])

    return (
        <>
            {loading ?
                <div className="loader-line"></div> :
                <main id="main" className="main">
                    <div className="pagetitle pagetitleFilters d-flex flex-wrap  justify-content-between align-items-start">
                        <h1>Session Discount</h1>
                        <Button variant="primary" size='sm' className='me-2 align-items-center' onClick={addNew} >+Add New</Button>
                    </div>
                    <div className="card">
                        <div className="card-body ">
                            {list.length > 0 ?
                                <div className="table-responsive">
                                    <table className="table dataTable" style={{ verticalAlign: "middle" }}>
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Discount</th>
                                                <th scope="col">Value</th>
                                                <th scope="col">Charger</th>
                                                <th scope="col">Total used</th>
                                                <th scope="col">Status</th>
                                                <th scope="col" width="200">Start / End Date</th>
                                                <th scope="col" width="200" style={{ minWidth: 200 }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {list.map((data, index) => {
                                                let updInd = index + 1
                                                return (
                                                    <tr key={index} style={{ cursor: "pointer" }}>
                                                        <td onClick={() => showModal(data, "view")}><strong>{((searchParams.get("page") || 1) - 1) * 20 + updInd}</strong></td>
                                                        <td onClick={() => showModal(data, "view")}>
                                                            <img src={data?.banner_image} alt='' style={{ maxHeight: "60px", maxWidth: "60px", marginRight: 10 }} />
                                                            <strong>{data?.title || ""}</strong>
                                                        </td>
                                                        <td onClick={() => showModal(data, "view")} className='text-capitalize'>{data?.discountPercentage || "0"}% <span className="badge text-capitalized bg-success ms-2">{data?.discountType || "Fixed"}</span></td>
                                                        <td onClick={() => showModal(data, "view")}>{data?.chargerType}</td>
                                                        <td onClick={() => showModal(data, "view")}>{data?.totalUses || 0}{data?.globalUsageLimit ? `/${data?.globalUsageLimit}` : ""}</td>
                                                        <td onClick={() => showModal(data, "view")}>
                                                            <span className={`badge text-capitalized ${data?.status === "ACTIVE" ? "bg-success" : "bg-danger"}`}>{data?.status}</span>
                                                        </td>
                                                        <td onClick={() => showModal(data, "view")}>{formatDate(data?.fixedStartDate)} <br /> <strong>to</strong> <br /> {formatDate(data?.fixedEndDate)}</td>
                                                        <td>
                                                            <div className='d-flex align-items-center justify-content-end'>
                                                                {data?.status !== "EXPIRED" ?
                                                                    <Form.Check
                                                                        className='mb-0'
                                                                        type="switch"
                                                                        name="isActive"
                                                                        checked={data?.isActive}
                                                                        // value={data?._id?._id}
                                                                        onChange={() => toggleStats(data)}
                                                                    />
                                                                    : null
                                                                }
                                                                <button className='btn btn-sm btn-outline-success' title='Logs' onClick={() => showModal(data, "logs")}> <Icon.FileEarmarkFill /> Logs </button>
                                                                {data?.status !== "EXPIRED" ?
                                                                    <button className='mx-2 btn btn-sm btn-primary' title='Edit discount' onClick={() => showModal(data, "edit")}> <Icon.PencilFill /> </button>
                                                                    : null
                                                                }
                                                                {data?.totalUses === 0 ?
                                                                    <button className='btn btn-sm btn-danger' title='Delete discount' onClick={() => showModal(data, "delete")}> <Icon.TrashFill /> </button>
                                                                    : null
                                                                }
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                :
                                <div className='text-center py-5'>
                                    <h3>No result found</h3>
                                </div>
                            }
                            <div style={{ maxWidth: "500px" }}>
                                <ResponsivePagination
                                    current={parseFloat(searchParams.get("page"))}
                                    total={count.length}
                                    onPageChange={setCurrentPage}
                                    disabled={params.page === count.length}
                                    // maxWidth={500}
                                    className={"pagination "}
                                />

                            </div>
                        </div>
                    </div>
                    <Modal show={modal.show} centered size={modal.type === "logs" ? "xl" : 'lg'} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title className='h5 modalTitleCstm text-capitalize'> {modal.title} </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {modal.type === "add" || modal.type === "edit" ? <>
                                <div className="row g-2 gy-3">
                                    <div className="col-md-12">
                                        {modal.type === "edit" ?
                                            <Form className='d-flex align-items-center '>
                                                <Form.Check
                                                    className='mb-0'
                                                    type="switch"
                                                    name="isActive"
                                                    // id={data?._id?._id}
                                                    label={value?.isActive ? "Enabled" : "Disabled"}
                                                    checked={value?.isActive}
                                                    // value={data?._id?._id}
                                                    onChange={toggleActiveState}
                                                />
                                            </Form>
                                            : null
                                        }
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label" htmlFor=""><strong>Main image</strong></label>
                                        <div className='logoUpdateBox d-block'>
                                            <input type='file' name="banner_image" className="form-control" accept="image/png, image/gif, image/jpeg" onChange={handleFileChange} />
                                            {preview ?
                                                <div className='mt-2'>
                                                    <div className='addnotificationPriview'>
                                                        <img src={preview && preview} alt="" />
                                                    </div>
                                                </div>
                                                : null
                                            }
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label" htmlFor=""><strong>Description image</strong></label>
                                        <div className='logoUpdateBox d-block'>
                                            <input type='file' name="header_image" className="form-control" accept="image/png, image/gif, image/jpeg" onChange={handleFileChange} />
                                            {preview2 ?
                                                <div className='mt-2'>
                                                    < div className='addnotificationPriview'>
                                                        <img src={preview2 && preview2} alt="" />
                                                    </div>
                                                </div>
                                                : null
                                            }
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label" htmlFor=""><strong>Title</strong></label>
                                        <input placeholder="" type="text" name="title" onChange={handleChange} className="form-control" value={value.title} />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label" htmlFor=""><strong>Sub title</strong></label>
                                        <input placeholder="" type="text" name="sub_title" onChange={handleChange} className="form-control" value={value.sub_title} />
                                    </div>
                                    <div className="col-md-12">
                                        <label className="form-label" htmlFor=""><strong>Description</strong></label>
                                        <MiniEditor
                                            editorState={editorState}
                                            updateTextDescription={updateTextDescription}
                                            onContentStateChange={onContentStateChange}
                                        />
                                    </div>


                                    <div className="col-md-3">
                                        <label className="form-label" htmlFor=""><strong>Discount Value (%)</strong></label>
                                        <input placeholder="eg: 10" type="number" name="discountPercentage" onChange={handleChange} className="form-control" value={value.discountPercentage} />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label" htmlFor=""><strong>Min Amount (RM)</strong></label>
                                        <input placeholder="eg: 10" type="number" name="min_value" onChange={handleChange} className="form-control" value={value.min_value} />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label" htmlFor=""><strong>Discount Up To (RM)</strong></label>
                                        <input placeholder="eg: 100" type="number" name="max_value" onChange={handleChange} className="form-control" value={value.max_value} />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label" htmlFor=""><strong>Charger type</strong></label>
                                        <select name="chargerType" onChange={handleChange} className="form-control" value={value.chargerType}>
                                            {ChargerType.map((x) => {
                                                return (
                                                    <option value={x} key={x}>{x}</option>
                                                )
                                            })}
                                        </select>
                                    </div>

                                    <div className="col-md-12">
                                        <Form className='d-flex align-items-center '>
                                            <Form.Check
                                                className='mb-0'
                                                type="switch"
                                                name="usageLimit"
                                                label={"Usage Limit"}
                                                checked={value.usageLimit}
                                                // value={data?._id?._id}
                                                onChange={toggleActiveState}
                                            />
                                        </Form>
                                    </div>
                                    {value.usageLimit ?
                                        <>
                                            <div className="col-md-6">
                                                <label className="form-label" htmlFor=""><strong>Limit per user</strong></label>
                                                <input placeholder="" type="number" name="usageLimitPerUser" onChange={handleChange} className="form-control" value={value.usageLimitPerUser} />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label" htmlFor=""><strong>Total Usage limit</strong></label>
                                                <input placeholder="" type="number" name="globalUsageLimit" onChange={handleChange} className="form-control" value={value.globalUsageLimit} />
                                            </div>
                                        </>
                                        : null
                                    }
                                    <div className="col-md-12">
                                        <Form className='d-flex align-items-center '>
                                            <Form.Check
                                                className='mb-0'
                                                type="switch"
                                                name="applicableOnPartners"
                                                label={"Applicable On Partners?"}
                                                checked={value.applicableOnPartners}
                                                // value={data?._id?._id}
                                                onChange={toggleActiveState}
                                            />
                                        </Form>
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label" htmlFor=""><strong>Include Chargers</strong></label>
                                        <Dropdown autoClose="outside" className='form-control form-dropdown'>
                                            <Dropdown.Toggle variant="" className='w-100 p-0 form-dropdown-button' id="dropdown-checkbox-toggle">
                                                {getDropdownLabel(value.includedChargers)}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu className="p-3" style={{ minWidth: '200px' }}>
                                                {chargerlist.map((option) => (
                                                    <div key={option._id} className="mb-2">
                                                        <Form.Check
                                                            type="checkbox"
                                                            id={`include-${option._id}`}
                                                            label={option.label || option.endpoint}
                                                            checked={(value.includedChargers || []).includes(option._id)}
                                                            onChange={() => handleCheckboxChange("includedChargers", option._id)}
                                                        />
                                                    </div>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label" htmlFor=""><strong>Exclude Chargers</strong></label>
                                        <Dropdown autoClose="outside" className='form-control form-dropdown'>
                                            <Dropdown.Toggle variant="" className='w-100 p-0 form-dropdown-button' id="dropdown-checkbox-toggle2">
                                                {getDropdownLabel(value.excludedChargers)}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu className="p-3" style={{ minWidth: '200px' }}>
                                                {chargerlist.map((option) => (
                                                    <div key={option._id} className="mb-2">
                                                        <Form.Check
                                                            type="checkbox"
                                                            id={`exclude-${option._id}`}
                                                            label={option.label || option.endpoint}
                                                            checked={(value.excludedChargers || []).includes(option._id)}
                                                            onChange={() => handleCheckboxChange("excludedChargers", option._id)}
                                                        />
                                                    </div>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>

                                    <div className="col-md-6 form-datepicker">
                                        <label className="form-label" htmlFor=""><strong>Start Date</strong></label>
                                        <DatePicker
                                            className=" form-control"
                                            selected={value.fixedStartDate}
                                            onChange={(date) => onDateChange(date, "fixedStartDate")}
                                            selectsStart
                                            startDate={value.fixedStartDate}
                                            endDate={value.fixedEndDate}
                                            placeholderText="Select Start Date"
                                            maxDate={new Date()}
                                            timeInputLabel="Time:"
                                            dateFormat="MM/dd/yyyy h:mm aa"
                                            showTimeInput
                                        />
                                    </div>
                                    <div className="col-md-6 form-datepicker">
                                        <label className="form-label" htmlFor=""><strong>End date</strong></label>
                                        <DatePicker
                                            className=" form-control"
                                            selected={value.fixedEndDate}
                                            onChange={(date) => onDateChange(date, "fixedEndDate")}
                                            selectsEnd
                                            startDate={value.fixedStartDate}
                                            endDate={value.fixedEndDate}
                                            minDate={value.fixedStartDate}
                                            placeholderText="Select End Date"
                                            timeInputLabel="Time:"
                                            dateFormat="MM/dd/yyyy h:mm aa"
                                            showTimeInput
                                        />
                                    </div>

                                </div>
                                <div className='mt-4'>
                                    <button className='btn btn-primary btn-sm' onClick={handleSubmit}>
                                        Save
                                    </button>
                                </div>
                            </> : null}
                            {modal.type == "delete" && <>
                                <div className='text-center mb-4'>
                                    <h4> Are you sure?</h4>
                                    <h5>You want to delete this discount.</h5>
                                </div>
                                <div className='text-center mt-2'>
                                    <button className='btn btn-danger btn-sm me-3' onClick={handleConfirm}> Confirm</button>
                                    <button className='btn btn-outline-danger btn-sm' onClick={handleClose} > Cancel</button>
                                </div>
                            </>}
                            {modal.type == "status" && <>
                                <div className='text-center mb-4'>
                                    <h4> Are you sure?</h4>
                                    <h5>You want to {modal.data.isActive ? "disable" : "enable"} this discount.</h5>
                                </div>
                                <div className='text-center mt-2'>
                                    <button className='btn btn-danger btn-sm me-3' onClick={handleConfirm}> Confirm</button>
                                    <button className='btn btn-outline-danger btn-sm' onClick={handleClose} > Cancel</button>
                                </div>
                            </>}
                            {modal.type === "view" ?
                                <div className='discount_detail'>
                                    <div className='d-flex gap-3 align-items-center justify-content-between'>
                                        <img src={itemData?.banner_image} alt='' style={{ maxHeight: "80px", maxWidth: "80px", marginRight: 10 }} />
                                        <div style={{ flex: 1 }}>
                                            <h4 className='mb-0'>{itemData?.title || ""}</h4>
                                            <p>{itemData?.sub_title || ""}</p>
                                        </div>
                                        <div className='text-end'>
                                            <strong>{formatDate(itemData?.createdAt)}</strong><br />
                                            <span className={`badge text-capitalized ${data?.isActive ? "bg-success" : "bg-danger"}`}>{data?.isActive ? "Active" : "Disabled"}</span>
                                        </div>
                                    </div>
                                    <div className='my-3 card'>
                                        <div className='p-3'>
                                            <img src={itemData?.header_image} alt='' className='img-fluid' style={{ maxHeight: "100px" }} />
                                            <div dangerouslySetInnerHTML={{ __html: itemData?.description }} className='mt-3'>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <ul className="list-group list-group-flush">
                                                <li className="list-group-item">
                                                    <strong>Value: </strong>
                                                    <span>{itemData?.discountPercentage || "0"}% <span className="badge text-capitalized bg-success">{itemData?.discountType || "Fixed"}</span></span>
                                                </li>
                                                <li className="list-group-item">
                                                    <strong>Charger type: </strong>
                                                    <span>{itemData?.chargerType}</span>
                                                </li>
                                                <li className="list-group-item">
                                                    <strong>Limit per user: </strong>
                                                    <span>{itemData?.usageLimitPerUser}</span>
                                                </li>
                                                <li className="list-group-item">
                                                    <strong>Total used: </strong>
                                                    <span>{itemData?.totalUses || 0}{itemData?.globalUsageLimit ? `/${itemData?.globalUsageLimit}` : ""}</span>
                                                </li>
                                                <li className="list-group-item">
                                                    <strong>On min amount: </strong>
                                                    <span><CurrencyFormat value={parseFloat(itemData?.min_value)} displayType={'text'} thousandSeparator={true} prefix={'RM '} /></span>
                                                </li>
                                                <li className="list-group-item">
                                                    <strong>On max amount: </strong>
                                                    <span><CurrencyFormat value={parseFloat(itemData?.max_value)} displayType={'text'} thousandSeparator={true} prefix={'RM '} /></span>
                                                </li>
                                                <li className="list-group-item">
                                                    <strong>Start date: </strong>
                                                    <span>{formatDate(itemData?.fixedStartDate)}</span>
                                                </li>
                                                <li className="list-group-item">
                                                    <strong>End date: </strong>
                                                    <span>{formatDate(itemData?.fixedEndDate)}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className='col-md-6'>
                                            <h6>Included Chargers</h6>
                                            {itemData.includedChargers.length ?
                                                <ul className='sidebar-nav discount_charger_list'>
                                                    {chargerlist.filter(item => itemData.includedChargers.includes(item._id)).map((option) => (
                                                        <li key={option._id} className="mb-1">
                                                            {option.label || option.endpoint}
                                                        </li>
                                                    ))}
                                                </ul>
                                                :
                                                <p>No charger added!</p>
                                            }
                                            <hr />
                                            <h6>Excluded Chargers</h6>
                                            {itemData.excludedChargers.length ?
                                                <ul className='sidebar-nav discount_charger_list'>
                                                    {chargerlist.filter(item => itemData.excludedChargers.includes(item._id)).map((option) => (
                                                        <li key={option._id} className="mb-1">
                                                            {option.label || option.endpoint}
                                                        </li>
                                                    ))}
                                                </ul>
                                                :
                                                <p>No charger added!</p>
                                            }
                                        </div>
                                    </div>
                                </div>
                                : null
                            }

                            {modal.type === "logs" ?
                                <>
                                    {logs.data && logs.data.length > 0 ?
                                        <div className="table-responsive">
                                            <table className="table dataTable" style={{ verticalAlign: "middle" }}>
                                                <thead>
                                                    <tr>
                                                        <th scope="col">User</th>
                                                        <th scope="col">Discount</th>
                                                        <th scope="col">Discount Value</th>
                                                        <th scope="col">Amount</th>
                                                        <th scope="col">Applied Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {logs.data.map((data, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    {data?.userId?.first_name || ""}<br />
                                                                    <small>{data?.userId?.email || ""}<br />
                                                                        {data?.userId?.phone_number || ""}<br />
                                                                    </small>
                                                                </td>
                                                                <td>
                                                                    <strong>{data?.title || ""}</strong>
                                                                </td>
                                                                <td className='text-capitalize'>{data?.discountValue || "0"}% <span className="badge text-capitalized bg-success ms-1">{data?.discountType || "Fixed"}</span></td>
                                                                <td><CurrencyFormat value={parseFloat(data?.amount)} displayType={'text'} thousandSeparator={true} prefix={'RM '} /></td>
                                                                <td>{formatDate(data?.appliedAt)}</td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                        :
                                        <div className='text-center py-5'>
                                            <h3>No result found</h3>
                                        </div>
                                    }
                                    <div style={{ maxWidth: "500px" }}>
                                        <ResponsivePagination
                                            current={parseFloat(logpage)}
                                            total={logsCount.length}
                                            onPageChange={setCurrentLogPage}
                                            disabled={logpage === logsCount.length}
                                            // maxWidth={500}
                                            className={"pagination "}
                                        />

                                    </div>
                                </>
                                : null
                            }

                        </Modal.Body>
                    </Modal >

                </main >
            }
        </>
    )
}
